import { render, staticRenderFns } from "./DeletePrivateSpace.vue?vue&type=template&id=6f5cd760"
import script from "./DeletePrivateSpace.vue?vue&type=script&lang=js"
export * from "./DeletePrivateSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports